var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSquareBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.125C12.3587 16.125 14.0381 16.125 15.0816 15.0816C16.125 14.0381 16.125 12.3587 16.125 9C16.125 5.64124 16.125 3.96186 15.0816 2.91843C14.0381 1.875 12.3587 1.875 9 1.875C5.64124 1.875 3.96187 1.875 2.91843 2.91843C1.875 3.96187 1.875 5.64124 1.875 9C1.875 12.3587 1.875 14.0381 2.91843 15.0816C3.96186 16.125 5.64124 16.125 9 16.125Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.75L6.75 11.2497M11.25 11.25L6.75 6.75029",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSquareBlack);
export default __webpack_public_path__ + "static/media/cancel-square-black.62b14e7c56faa59702f170d39cdb7a65.svg";
export { ForwardRef as ReactComponent };